import styled, { css } from 'styled-components';

const linearGrey = `linear-gradient(
  240deg,
  rgba(255, 255, 255, 0) 0%,
  rgba(255, 255, 255, 0.3) 100%
)`;

export const Container = styled.div`
  width: 100%;
  max-width: 900px;
  margin: 0 auto;
  padding: 24px;
`;

export const TabsNavigation = styled.div`
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.grey[200]};
`;

export const Tab = styled.button`
  flex: 1;
  padding: 16px;
  background: ${({ $active, theme }) =>
    $active ? theme.colors.primary.main : 'transparent'};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.grey.white : theme.colors.grey[500]};
  border: none;
  border-bottom: 3px solid
    ${({ $active, theme }) =>
      $active ? theme.colors.primary.main : 'transparent'};
  cursor: pointer;
  transition: all 0.3s;
  position: relative;

  &:hover {
    background: ${({ $active, theme }) =>
      $active ? theme.colors.primary.main : theme.colors.grey[100]};
  }

  h4 {
    margin: 0;
  }
`;

export const CheckIcon = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 20px;
  height: 20px;
  background: ${({ theme }) => theme.colors.success};
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

export const Badge = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  background: ${({ theme }) => theme.colors.primary.main};
  color: white;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: bold;
`;

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  margin-bottom: 40px;
  padding-bottom: 64px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey.white};

  h1 {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
    font-size: 56px;
  }
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 24px;
  border-top: 2px solid ${({ theme }) => theme.colors.grey[200]};
`;

export const ProgressInfo = styled.div`
  span {
    color: ${({ theme }) => theme.colors.grey[500]};
    font-size: 14px;
  }
`;
export const Button = styled.button`
  width: 100%;
  padding: 16px;
  position: relative;
  color: ${({ theme }) => theme.colors.grey.white};
  border-radius: 32px;
  border: 0;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  z-index: 0;

  /* Estado padrão */
  background: ${({ $isActive }) =>
    $isActive
      ? css`linear-gradient(
          90deg,
          rgba(224, 79, 17, 0.4) 0%,
          rgba(228, 35, 32, 0.4) 48%,
          rgba(102, 20, 14, 0.4) 100%
        )`
      : css`
          ${linearGrey}
        `};

  ${({ $isActive }) =>
    $isActive &&
    css`
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(224, 79, 17, 0.2),
        0 8px 24px rgba(228, 35, 32, 0.15);
    `}

  &::after {
    content: '';
    position: absolute;
    inset: 0;
    border-radius: 32px;
    padding: 2px;
    opacity: 1;
    transition: all 0.4s ease;
    z-index: -1;
    -webkit-mask: linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask-composite: exclude;

    /* Borda padrão ou ativa */
    background: ${({ $isActive }) =>
      $isActive
        ? css`linear-gradient(
            90deg,
            rgba(224, 79, 17, 1) 0%,
            rgba(228, 35, 32, 1) 48%,
            rgba(102, 20, 14, 1) 100%
          )`
        : css`linear-gradient(
            240deg,
            rgba(255, 255, 255, 0.1) 0%,
            rgba(255, 255, 255, 0.5) 100%
          )`};

    ${({ $isActive }) =>
      $isActive &&
      css`
        animation: subtleShine 2s ease-in-out infinite;
      `}
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(224, 79, 17, 0.2),
      0 8px 24px rgba(228, 35, 32, 0.15);
    background: linear-gradient(
      90deg,
      rgba(224, 79, 17, 0.4) 0%,
      rgba(228, 35, 32, 0.4) 48%,
      rgba(102, 20, 14, 0.4) 100%
    );

    &::after {
      opacity: 1;
      background: linear-gradient(
        90deg,
        rgba(224, 79, 17, 1) 0%,
        rgba(228, 35, 32, 1) 48%,
        rgba(102, 20, 14, 1) 100%
      );
      animation: subtleShine 2s ease-in-out infinite;
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(224, 79, 17, 0.2);
  }

  /* Desabilita hover se estiver ativo */
  ${({ $isActive }) =>
    $isActive &&
    css`
      &:hover {
        transform: translateY(-2px);
      }
    `}

  @keyframes subtleShine {
    0%,
    100% {
      filter: brightness(1);
    }
    50% {
      filter: brightness(1.15);
    }
  }
`;

// ✅ Filters Section - Estilos do documento
export const FiltersContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  padding-bottom: 64px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey.white};

  h1 {
    font-family: 'Anton', sans-serif;
    text-transform: uppercase;
    font-size: 56px;
  }
`;

export const FiltersRow = styled.div`
  width: 100%;
  display: flex;
  gap: 32px;
  margin-top: 32px;
  margin-bottom: 32px;

  @media ${({ theme }) => theme.devices.mobile} {
    flex-direction: column;
  }
`;

export const FiltersColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const VerticalDivider = styled.div`
  width: 1px;
  background: ${({ theme }) => theme.colors.grey.white};

  @media ${({ theme }) => theme.devices.mobile} {
    display: none;
  }
`;

export const FilterGroup = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px;
  padding-bottom: 32px;
  gap: 12px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grey.white};

  &:last-child {
    border-bottom: none;
  }
`;

export const FilterButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  flex-wrap: ${({ $wrap }) => ($wrap ? 'wrap' : 'nowrap')};

  ${({ $wrap }) =>
    $wrap &&
    css`
      > button {
        flex: 0 0 calc(50% - 6px);
        max-width: calc(50% - 6px);
      }
    `}
`;

export const FilterButton = styled.button`
  width: 100%;
  padding: 10px 24px;
  border-radius: 32px;
  border: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap;
  flex: ${({ $wrap }) => ($wrap ? '0 0 auto' : '1')};

  ${({ $isActive }) =>
    $isActive
      ? css`
          background: linear-gradient(
            90deg,
            rgba(224, 79, 17, 1) 0%,
            rgba(228, 35, 32, 1) 100%
          );
          color: ${({ theme }) => theme.colors.grey.white};
          box-shadow: 0 4px 12px rgba(224, 79, 17, 0.3);
          transform: translateY(-2px);
        `
      : css`
          background: rgba(255, 255, 255, 0.9);
          color: ${({ theme }) => theme.colors.grey.dark};

          &:hover {
            background: rgba(255, 255, 255, 1);
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
          }
        `}

  &:active {
    transform: translateY(0);
  }
`;

export const FilterInput = styled.input`
  width: 100%;
  padding: 16px 24px;
  border-radius: 32px;
  border: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`;

// ✅ Services Section
export const ServicesContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;

  h3 {
    margin-bottom: 8px;
    text-align: center;
  }

  > span {
    display: block;
    margin-bottom: 24px;
    text-align: center;
  }
`;

export const ServiceGroup = styled.div`
  padding: 20px;
  border-radius: 12px;
  transition: all 0.3s;

  &:hover {
    border-color: rgba(255, 255, 255, 0.4);
    transform: translateY(-2px);
  }

  label {
    display: block;
    font-weight: 600;
    margin-bottom: 4px;
    color: ${({ theme }) => theme.colors.grey.white};
  }

  small {
    display: block;
    color: ${({ theme }) => theme.colors.grey[200]};
    margin-bottom: 16px;
  }
`;

export const Selected = styled.div`
  padding: 8px 12px;
  background: linear-gradient(
    90deg,
    rgba(224, 79, 17, 0.2) 0%,
    rgba(228, 35, 32, 0.2) 100%
  );
  border-radius: 8px;
  margin-bottom: 12px;
  border: 1px solid rgba(224, 79, 17, 0.4);

  span {
    color: ${({ theme }) => theme.colors.grey.white};
    font-weight: 600;
    font-size: 14px;
  }
`;

export const ServiceOptions = styled.div`
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
  flex-wrap: wrap;
`;

export const ServiceOption = styled.button`
  flex: 1;
  min-width: 120px;
  padding: 12px;
  border-radius: 32px;
  border: none;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  ${({ $checked }) =>
    $checked
      ? css`
          background: linear-gradient(
            90deg,
            rgba(224, 79, 17, 1) 0%,
            rgba(228, 35, 32, 1) 100%
          );
          color: ${({ theme }) => theme.colors.grey.white};
          box-shadow: 0 4px 12px rgba(224, 79, 17, 0.3);
          transform: translateY(-2px);
        `
      : css`
          background: rgba(255, 255, 255, 0.9);
          color: ${({ theme }) => theme.colors.grey.dark};

          &:hover {
            background: rgba(255, 255, 255, 1);
            transform: translateY(-2px);
            box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
          }
        `}

  &:active {
    transform: translateY(0);
  }

  span {
    font-size: 14px;
  }
`;

export const ButtonRemove = styled.button`
  width: 100%;
  padding: 8px;
  background: transparent;
  color: ${({ theme }) => theme.colors.grey.white};
  border: 1px dashed rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    background: rgba(255, 0, 0, 0.1);
    border-color: rgba(255, 0, 0, 0.5);
    transform: translateY(-2px);
  }

  span {
    font-size: 13px;
  }
`;
